import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { MatMenuTrigger } from '@angular/material/menu';
import { MsgModel } from '../../msg/model/msg.model';
import { AccessService } from 'src/app/component/navigation/service/access.service';
import { HelpTextStorageService } from '../service/help-text-storage.service';
import { HelpText, HelpTextBody, HelpTextFooter, HelpTextHeader } from '../model/helpText.model';
import { EditHelpTextComponent } from '../edit-help-text/edit-help-text.component';
import { ActivatedRoute, Router } from '@angular/router';
import { HelpTextService } from '../service/help-text.service';
import { Observable, of } from 'rxjs';

@Component({
    selector: 'help-text-btn',
    templateUrl: './help-text-btn.component.html',
    styleUrl: './help-text-btn.component.scss'
})
export class HelpTextBtnComponent implements OnInit {
    @Input() helpTextId!: string;

    @ViewChild('menuTrigger') menuTrigger!: MatMenuTrigger;

    helpText: HelpText;
    helpText$: Observable<HelpText>;
    isLoading: boolean = false;
    isOpen: boolean = false;
    disabled: boolean = false;

    msg: MsgModel;

    // Permissions
    hasPermission: boolean;

    constructor(
        private dialog: MatDialog,
        public accessService: AccessService,
        private helpTextStorageService: HelpTextStorageService,
        private helpTextService: HelpTextService,
        private route: ActivatedRoute,
        private router: Router
    ) { }

    ngOnInit(): void {
        this.init();

        this.helpText$ = this.helpTextStorageService.getHelpText(this.helpTextId);
    }

    init() {
        this.getFeaturePermissions();
        this.getHelpTexts();
    }

    getFeaturePermissions() {
        this.hasPermission = this.accessService.verifyUserRole('System Administrator');
    }

	getHelpTexts() {
	        //console.log("grabbing ALL helptexts from parent")
	        if (this.helpTextId=='') {   
	            console.log("when helpTextId was blank")         
	            this.createEmptyHelpText();
	        }
	        else {
	            // console.log("referencing:",this.helpTextId);	                        	            
	            // console.log("initially we have this:")
	            // console.log(this.helpTextStorageService.helpTexts);
	                
                this.helpTextStorageService.getHelpText(this.helpTextId).subscribe((helpText: HelpText) => {
                    // console.log("got a match here:");
                    // console.log(helpText);            	                    
	            });
	
	        }
	    }
	    
    getHelpText() {
        if (this.helpTextId=='') {            
            this.createEmptyHelpText();
        }
        else {
            this.helpTextStorageService.getHelpText(this.helpTextId).subscribe((helpText: HelpText) => {
                this.helpText = helpText;

                if (this.helpText.createdBy && this.hasPermission) {
                    this.tagHelpText(helpText);
                }
            });
        }
    }

    createEmptyHelpText() {
        this.helpText = new HelpText();
        this.helpText$ = of(new HelpText());
        this.helpText.id = 'DummyId';
        var htHeader=new HelpTextHeader();
        htHeader.text="No Help Text Available";
        this.helpText.header = htHeader;
        var htBody=new HelpTextBody();
        htBody.text="Please contact your system administrator to create help text for this page.";
        this.helpText.bodies = [htBody];

        var htFooter=new HelpTextFooter();
        htFooter.text="Help Text is not available for this page.";
        this.helpText.footer = htFooter;
        this.helpText.createdBy = 'testUser';
        this.helpText.modifiedBy = 'testUser';
        this.helpText.createdDate = new Date();
        this.helpText.modifiedDate = new Date();

    }

    tagHelpText(helpText: HelpText) {
        let newTagFlag = false;
        let routeUrl;
        let routeController;
        let parentController;

        if (
            !helpText.routeUrls ||
            (helpText.routeUrls && helpText.routeUrls?.findIndex((routeUrl) => routeUrl === this.router.url.replace(/\/\d+/g, '/:id')) === -1)
        ) {
            routeUrl = this.router.url.replace(/\/\d+/g, '/:id');
            newTagFlag = true;
        }

        if (newTagFlag && this.hasPermission) {
            this.helpTextService.tag(this.helpTextId, routeUrl, routeController, parentController).subscribe((res) => { });
        }
    }

    openDialogEdit(ht?: HelpText) {
        let payload: any = {};
        payload.helpTextId = this.helpTextId;
        if (ht)
        {
	        payload.helpText = ht;
        }
        else
        {
        	payload.helpText = this.helpText;        
        }
        if (this.router?.url)
        {
            payload.routeUrl = this.router.url.replace(/\/\d+/g, '/:id');
        }
        const dialogConfig = new MatDialogConfig();
        dialogConfig.disableClose = true;
        dialogConfig.data = payload;
        dialogConfig.maxHeight = '99vh';
        dialogConfig.minWidth = '50vw';
        const dialogRef = this.dialog.open(EditHelpTextComponent, dialogConfig);

        dialogRef.afterClosed().subscribe((res: any) => {
            if (res && (res.refresh || res.helpText)) {
                this.helpTextStorageService.updateHelpText(res.helpText);   
              //  this.getHelpText();
            	
            }
        });
    }

    openMenu() {
        //this.menuTrigger.openMenu();
        this.isOpen = true;
    }

    closeMenu() {
        this.isOpen = false;
        this.menuTrigger.closeMenu();
    }
}
